import { render, staticRenderFns } from "./SelectedStatisticsFilters.vue?vue&type=template&id=120eb4ee"
import script from "./SelectedStatisticsFilters.vue?vue&type=script&lang=js"
export * from "./SelectedStatisticsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports